// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export
export { default as routes } from './routes'
export { default as vuex } from './vuex'



// WEBPACK FOOTER //
// ./src/app/auth/index.js